import { Fragment, useRef, useState } from "react"

import useTranslator from "@pma/hooks/use-translator"
import { DictType } from "@pma/types"
import { cn } from "@pma/utils/helpers"
import { Printer } from "lucide-react"
import { Dialog, DialogContent, DialogTrigger } from "@components/common/dialog"
import { Button } from "@components/common/button"
import Invoice from "./invoice"
import { useReactToPrint } from "react-to-print"
import { Separator } from "@components/common/separator"
import { Label } from "../common/label"
import { Switch } from "../common/switch"
import MainBoqInvoice from "./main-boq-invoice"

const BillPrintTemplate = ({ bill, mainBoQDetails, status, onOpenChange }: DictType) => {
  const { translate, locale } = useTranslator()
  const billRef = useRef<HTMLDivElement>(null)

  const [showEntireBill, setShowEntireBill] = useState(false)

  const isHebrew = locale === "he"

  const printBill = useReactToPrint({ contentRef: billRef, documentTitle: bill?.number })

  return (
    <Fragment>
      <Dialog onOpenChange={onOpenChange}>
        <DialogTrigger>
          <Button variant={"outline"} size={"sm"}>
            <Printer className={`mx-1 h-4 w-4`} />
            <span className='hidden sm:inline'>{translate("Print")}</span>
          </Button>
        </DialogTrigger>
        <DialogContent
          className={cn(
            "flex h-full max-h-[95vh] w-full flex-col overflow-y-hidden md:max-w-2xl lg:max-w-3xl xl:max-w-7xl",
            isHebrew ? "rtl" : "ltr",
          )}
        >
          <div className='flex gap-2'>
            <Button variant={"default"} onClick={() => printBill()} className='h-8 w-[100px]'>
              <Printer className={`mx-1 h-4 w-4`} />
              {translate("Print")}
            </Button>
            <div className='flex items-center gap-2'>
              <Label htmlFor='entire-bill-switch' className='text-xs'>
                {translate("Entire Bill")}
              </Label>
              <Switch
                id='entire-bill-switch'
                checked={showEntireBill}
                onCheckedChange={(checked) => setShowEntireBill(checked)}
              />
            </div>
          </div>
          <Separator />

          <style>
            {`
          @media print {
            @page {
              size: landscape;
            }
          }
        `}
          </style>
          <div className='flex-1 overflow-y-auto' ref={billRef}>
            {showEntireBill ? <MainBoqInvoice bill={mainBoQDetails} mainDetails={bill} /> : <Invoice bill={bill} status={status} />}
          </div>
        </DialogContent>
      </Dialog>
    </Fragment>
  )
}

export default BillPrintTemplate
